<template>
  <button
    type="button"
    name="main-button"
    class="main-button-wrapper"
    :class="[
      type,
      size === 'sm' ? 'small' : '',
      invert ? 'inverted-colors' : '',
      disabled ? 'disabled' : ''
    ]"
  >
    <slot></slot>
  </button>
</template>

<script>

export default {
  props: {
    type: {
      type: String,
      default: 'primary', // 'primary', 'secondary', 'tertiary', or 'cancel'
    },
    size: {
      type: String,
      default: 'lg', // 'sm' or 'lg'
    },
    invert: Boolean,
    disabled: Boolean,
  },
};

</script>
<style scoped>
  .main-button-wrapper {
    font-family: "Work Sans", sans-serif;
    display: inline;
    -webkit-appearance: none;
    cursor: pointer;
    outline: none;
    font-size: 14px;
    letter-spacing: 0.5px;
    color: #fff;
    padding: 6px 14px;
    border-radius: 3px;
    box-shadow: 0px 3px 4px rgba(0,0,0,0.09);
    margin: 5px 0;
  }

  .main-button-wrapper.small {
    font-size: 10px;
    padding: 3px 8px;
  }

  .main-button-wrapper:hover {
    opacity: 0.9;
  }

  .main-button-wrapper.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .main-button-wrapper.primary {
    background: #5cbd85;
    border: 1px solid #5cbd85;
  }

  .main-button-wrapper.secondary {
    background: #668cf5;
    border: 1px solid #668cf5;
  }

  .main-button-wrapper.tertiary {
    background: #e6e6e6;
    border: 1px solid #e6e6e6;
    color: #8e8e8e;
    box-shadow: none;
  }

  .main-button-wrapper.cancel {
    background: transparent;
    color: #fb4d4d;
    border: none;
    box-shadow: none;
  }

  .main-button-wrapper.inverted-colors {
    background: #fff;
  }

  .main-button-wrapper.inverted-colors:hover {
    background: #e8f0f7;
  }

  .main-button-wrapper.primary.inverted-colors {
    color: #5cbd85;
  }

  .main-button-wrapper.secondary.inverted-colors {
    color: #668cf5;
  }

  .main-button-wrapper.cancel.inverted-colors {
    border: 1px solid #fb4d4d;
  }
</style>
